import { useSearchParams } from "react-router-dom";
import LazyRabbitSign from "./RabbitSign";

export default function RabbitSignPage() {
    const [params] = useSearchParams();
    const fileDatabaseId = params.get("fileDatabaseId");

    if (!fileDatabaseId) return null;

    return (
        <div
            style={{
                height: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#f5f7fa",
            }}
        >
            <button
                className="btn btn-primary"
                onClick={() => window.location.reload()}
                style={{
                    padding: "14px 28px",
                    fontSize: "16px",
                    fontWeight: 600,
                    color: "#fff",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                }}
            >
                View Document
            </button>
            <LazyRabbitSign
                fileDatabaseId={fileDatabaseId}
                GenerateAndSendToSign={() => { }}
            />
        </div>
    );
}
